<script setup>
// Avisos de nova mensagem do Chat Interno, no canto da tela, dentro do Fluxi.
// Quem decide se aparece é helper/AudioAlerts/alertasDoChatInterno.js.
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import {
  avisos,
  fecharAviso,
} from 'dashboard/helper/AudioAlerts/alertasDoChatInterno';

const router = useRouter();
const { t } = useI18n();
const { accountId } = useAccount();

const abrir = aviso => {
  fecharAviso(aviso.id);
  router.push({
    name: 'internal_chat_channel',
    params: { accountId: accountId.value, channelId: aviso.canalId },
  });
};
</script>

<template>
  <div
    class="fixed z-50 flex flex-col gap-2 pointer-events-none top-3 right-3 w-80 max-w-[calc(100vw-1.5rem)]"
    role="status"
    aria-live="polite"
  >
    <div
      v-for="aviso in avisos"
      :key="aviso.id"
      class="flex items-start gap-3 p-3 rounded-xl shadow-lg cursor-pointer pointer-events-auto bg-n-solid-2 outline outline-1 outline-n-weak hover:bg-n-solid-3"
      @click="abrir(aviso)"
    >
      <Avatar :src="aviso.avatar" :name="aviso.nome" :size="32" rounded-full />
      <div class="flex-1 min-w-0">
        <p class="text-xs font-medium text-n-blue-11">
          {{ t('INTERNAL_CHAT.AVISO.TITULO') }}
        </p>
        <p class="text-sm font-medium truncate text-n-slate-12">
          {{ aviso.titulo }}
        </p>
        <p class="text-sm text-n-slate-11 line-clamp-2 break-words">
          {{ aviso.texto || t('INTERNAL_CHAT.AVISO.ANEXO') }}
        </p>
      </div>
      <button
        type="button"
        class="flex items-center justify-center rounded size-6 text-n-slate-11 hover:bg-n-alpha-2"
        :aria-label="t('INTERNAL_CHAT.AVISO.FECHAR')"
        @click.stop="fecharAviso(aviso.id)"
      >
        <span class="i-lucide-x size-4" />
      </button>
    </div>
  </div>
</template>
